import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Input, FormGroup, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Title } from '../../Shared';
import { AdminHeader } from '../';
import { smsActions } from '../../_actions';

function Send(props) {
  const { count, getCount, sending, sent } = props;
  const [content, setContent] = useState('');

  useEffect(() => {
    getCount();
  }, [getCount]);

  // reset form on send.
  useEffect(() => {
    if (sent) {
      setContent('');
    }
  }, [sent]);

  const send = e => {
    e.preventDefault();
    if (content) {
      props.sendToAll(content);
    }
  };

  return (
    <Fragment>
      <Title text="Send SMS" />
      <AdminHeader title="Send SMS" goBack />
      <Container className="mt-4">
        <Row>
          <Col>
            <p>This message will be sent to {count} users.</p>
            <FormGroup>
              <Input type="textarea" value={content} onChange={e => setContent(e.target.value)} />
              <div>
                <div className="float-left small">SMS are $0.055 each per 160 characters.</div>
                <div className="float-right small">{content.length} / 160</div>
              </div>
            </FormGroup>
            <FormGroup className="pt-1">
              {sending ? (
                <Button color="primary" disabled>
                  <FontAwesomeIcon icon="spinner" spin /> Sending
                </Button>
              ) : (
                <Button color="primary" onClick={send}>
                  Send
                </Button>
              )}
            </FormGroup>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

const mapDispatch = {
  getCount: smsActions.recipientCount,
  sendToAll: smsActions.sendToAll
};

function mapState(state) {
  const { count, sending, sent } = state.sms;
  return { count, sending, sent };
}

const connectedSend = connect(
  mapState,
  mapDispatch
)(Send);
export { connectedSend as Send };
